import React, { useContext, forwardRef, useImperativeHandle } from 'react'
import myContext from '../context/context'
import PropTypes from 'prop-types'
import GetSearchResult from '../../Utility/GetSearchResult/GetSearchResult'
import { isFilterApplied, distanceFromSubject } from '../../Utility/Utility.js'
// import { AuthContext } from '../../../../context/AuthContext'

const ApplyFilters = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        callhandleClick() {
            handleClick()
        }
    }),
    )

    const { searchFields, searchCriteria, setSearchCriteria, setShowSpinner, setSearchResult, setShowAlert, setalertProps } = useContext(myContext)
    const { criteriaToApply, handleClose } = props
    // const keycloak = useContext(AuthContext)

    function loadData(response, isError) {
        if (!isError) {
            if (response.data && response.data.data) {

                let data = response.data.data
                if (searchCriteria.subjectProperty.propertyName) {
                    data = distanceFromSubject(data, searchCriteria)
                }

                setSearchResult({ property: data, totalCount: response.data.total })
            }
        }
        setShowSpinner(false)
    }

    const handleClick = async () => {

        const newSearchCriteria = searchCriteria

        newSearchCriteria.pagination.from = 0
        // searchFields.isLocationLoaded = false
        if (criteriaToApply === 'propertyTypeFields' || criteriaToApply === 'all') {

            newSearchCriteria.propertyTypeFields = []
            setSearchCriteria({ ...newSearchCriteria })

            const lstPropertyTypes = searchFields.propertyTypeFields.filter(x => x.subtype === 'all')

            lstPropertyTypes.forEach(item => {

                if (item.isChecked) {
                    newSearchCriteria.propertyTypeFields.push(item)
                } else {
                    const subtypes = searchFields.propertyTypeFields.filter(x => x.propertytype === item.propertytype && x.subtype !== 'all')
                    subtypes.forEach(subItem => {
                        if (subItem.isChecked) {
                            newSearchCriteria.propertyTypeFields.push(subItem)
                        }
                    })
                }

            })
            setSearchCriteria({ ...newSearchCriteria })
        }

        if (criteriaToApply === 'featureFields' || criteriaToApply === 'all') {

            newSearchCriteria.featureFields = []
            setSearchCriteria({ ...newSearchCriteria })

            searchFields.featureFields.forEach(item => {
                if (item.minValue !== '' || item.maxValue !== '') {
                    newSearchCriteria.featureFields.push(item)
                }
            })

            setSearchCriteria({ ...newSearchCriteria })
        }
        if (criteriaToApply === 'salesFields' || criteriaToApply === 'all') {
            newSearchCriteria.salesFields = []
            setSearchCriteria({ ...newSearchCriteria })
            searchFields.salesFields.forEach(item => {
                if (item.minValue || item.maxValue || item.startValue || item.endValue) {
                    newSearchCriteria.salesFields.push(item)
                }
            })

            setSearchCriteria({ ...newSearchCriteria })
        }
        if (criteriaToApply === 'listingStatusFields' || criteriaToApply === 'all') {

            newSearchCriteria.listingStatusFields = []
            setSearchCriteria({ ...newSearchCriteria })
            searchFields.listingStatusFields.forEach(item => {
                if (item.isVisible && item.isChecked) {
                    newSearchCriteria.listingStatusFields.push(item)
                }
                if (item.type === 'date') {
                    if (item.startValue || item.endValue) {
                        if (item.startValue && !item.endValue) {
                            item.endValue = '*'
                        }
                        if (!item.startValue && item.endValue) {
                            item.startValue = '*'
                        }
                        newSearchCriteria.listingStatusFields.push(item)
                    }
                }
            })
            setSearchCriteria({ ...newSearchCriteria })
        }

        if (criteriaToApply === 'distanceFields' || criteriaToApply === 'all') {
            if (searchCriteria.subjectProperty.propertyName) {
                newSearchCriteria.distanceFields = []
                newSearchCriteria.distanceFields.push(searchFields.distanceFields[0])
                setSearchCriteria({ ...newSearchCriteria })
            }
        }

        if (criteriaToApply === 'tenantInfoFields' || criteriaToApply === 'all') {
            newSearchCriteria.tenantInfoFields = []
            setSearchCriteria({ ...newSearchCriteria })
            let isUpdated = false
            searchFields.tenantInfoFields.forEach(item => {
                if (item.groupList) {
                    let flag = false
                    item.groupList.forEach(list => {
                        if (list.selected) {
                            if (item.type === 'radio' && isUpdated === true) {
                                flag = true
                                list.isChanged = true
                            } else if (item.type === 'checkbox') {
                                flag = true
                                isUpdated = true
                            }
                        }
                    })
                    if (flag) {
                        newSearchCriteria.tenantInfoFields.push(item)
                    }
                }
            })
            setSearchCriteria({ ...newSearchCriteria })
        }

        if (criteriaToApply === 'accountFields' || criteriaToApply === 'all') {
            newSearchCriteria.accountFields = []

            if (searchFields.accountFields[0].accountId !== '') {
                newSearchCriteria.accountFields.push(searchFields.accountFields[0])
                newSearchCriteria.accountFields.push(searchFields.accountFields[1])
            }

            setSearchCriteria({ ...newSearchCriteria })
        }

        if (criteriaToApply === 'loanFields' || criteriaToApply === 'all') {

            newSearchCriteria.loanFields = []
            setSearchCriteria({ ...newSearchCriteria })
            searchFields.loanFields.forEach(item => {
                if (item.minValue || item.maxValue || item.startValue || item.endValue) {
                    newSearchCriteria.loanFields.push(item)
                }
                if (item.optionsList && item.value) {
                    newSearchCriteria.loanFields.push(item)
                }
                if (item.groupList && ((item.startValue || item.endValue))) {
                    newSearchCriteria.loanFields.push(item)
                }

            })
            setSearchCriteria({ ...newSearchCriteria })
        }
        if (criteriaToApply === 'locationFields' || criteriaToApply === 'all') {

            newSearchCriteria.locationFields = []
            setSearchCriteria({ ...newSearchCriteria })
            const lstPropertyTypes = searchFields.locationFields.filter(x => x.locationValue === 'all')
            lstPropertyTypes.forEach(item => {
                const subtypes = searchFields.locationFields.filter(x => x.locationType === item.locationType && x.locationValue !== 'all')
                subtypes.forEach(subItem => {
                    if (subItem.isChecked) {
                        newSearchCriteria.locationFields.push(subItem)
                    }
                })
            })
            setSearchCriteria({ ...newSearchCriteria })
        }

        if (isFilterApplied(searchCriteria)) {
            setShowSpinner(true)
            // setSearchResult({ property: [], totalCount: 0 })
            // const searchResult = new GetSearchResult(searchCriteria, loadData)
            // searchResult.fetchSearchResult()

            const searchResult = new GetSearchResult(newSearchCriteria, function () { })
            const response = await searchResult.fetchSearchResult()
            // console.log('response:::', response)
            setShowSpinner(false)
            loadData(response, false)

            handleClose()
        } else {
            setShowSpinner(false)
            setalertProps({ message: 'No filter selected', type: 'error' })
            setShowAlert(true)
        }

        // console.log('apply newSearchCriteria:::', newSearchCriteria)
        // console.log('apply searchFields:::', searchFields)
    }

    return (
        <>
            <div>
                <button data-testid="test-button-apply" id="btn-apply-button" onClick={handleClick} className="btn btn-sm btn-primary">Apply</button>
            </div>
        </>
    )
})

export default ApplyFilters

ApplyFilters.propTypes = {
    criteriaToApply: PropTypes.string,
    handleClose: PropTypes.any
}
